// All data-testid constants in one place
export const TID = {
    // Layout / nav
    headerLogo: "header-logo",
    langToggle: "lang-toggle",
    mobileMenuBtn: "mobile-menu-btn",
    navHome: "nav-home",
    navAbout: "nav-about",
    navDeposits: "nav-deposits",
    navLoans: "nav-loans",
    navCalculator: "nav-calculator",
    navContact: "nav-contact",
    navMembership: "nav-membership",
    whatsappFab: "whatsapp-fab",

    // Home
    heroCtaContact: "hero-cta-contact",
    heroCtaMember: "hero-cta-member",
    statCard: (k) => `stat-${k}`,
    serviceCard: (k) => `service-${k}`,
    testimonialCard: (i) => `testimonial-${i}`,

    // Calculator
    calcScheme: "calc-scheme",
    calcAmount: "calc-amount",
    calcTenure: "calc-tenure",
    calcSenior: "calc-senior",
    calcResult: "calc-result",
    calcResultInterest: "calc-result-interest",
    calcResultInvested: "calc-result-invested",
    calcRate: "calc-rate",

    // Forms
    contactName: "contact-name",
    contactMobile: "contact-mobile",
    contactEmail: "contact-email",
    contactQuery: "contact-query",
    contactMessage: "contact-message",
    contactSubmit: "contact-submit",
    contactSuccess: "contact-success",
    contactWhatsapp: "contact-whatsapp",

    memberName: "member-name",
    memberMobile: "member-mobile",
    memberEmail: "member-email",
    memberAddress: "member-address",
    memberScheme: "member-scheme",
    memberMessage: "member-message",
    memberSubmit: "member-submit",
    memberSuccess: "member-success",

    // Tabs
    depositTabFd: "tab-fd",
    depositTabFdSenior: "tab-fd-senior",
    depositTabMip: "tab-mip",
    depositTabMipSenior: "tab-mip-senior",
    depositTabRd: "tab-rd",
    depositTabSpecial: "tab-special"
};
